






















































































import { snakeCase, cloneDeep } from 'lodash'
import { ValidationObserver } from 'vee-validate'
import Vue from 'vue'
import { Component, Emit, Prop, Watch } from 'vue-property-decorator'

import { VueComponent } from '../../../../../shared/types/VueComponent'
import ButtonsManager from '../../ButtonsConstructor/ButtonsManager'
import Button, { ButtonStruct } from '../../ButtonsConstructor/buttons'
import ButtonSettingsView from './ButtonSettingsView.vue'

@Component({
  components: {
    ValidationObserver,
    ButtonSettingsView
  },
  data() {
    return {
      snakeCase,
      cloneDeep,
    }
  }
})
export default class ButtonsBuildManagerPhone extends Vue {
  @Prop() struct!: ButtonStruct | null

  @Prop() manager!: ButtonsManager

  @Prop() buttonsHelpView!: VueComponent | string

  @Watch('struct')
  structWatcher(struct: ButtonStruct | null): void {
    if (struct) {
      this.addedButton = true
      this.currentButton = this.manager.buttons[struct.type]

      this.currentButton.data = cloneDeep(struct)
      this.oldGuid = struct.guid
    } else {
      this.currentButton = null
      this.addedButton = false
      this.oldGuid = ''
    }
  }

  addedButton = false

  currentButton: null | Button = null

  oldGuid = ''

  addedButtonOnHandler(): void {
    this.addedButton = true

    if (this.manager.soloButton) {
      this.currentButton = this.manager.firstButton
    }
  }

  addedButtonOffHandler(): void {
    if (this.struct) {
      this.currentButton = null
    }

    this.addedButton = false
    this.unselect()
  }

  currentButtonBackHandler(): void {
    if (this.struct) {
      this.addedButtonOffHandler()
    } else {
      this.currentButton = null
    }
  }

  @Emit()
  addButton(): ButtonStruct | void {
    if (this.currentButton) {
      this.addedButton = false
      const struct = this.currentButton.create()
      this.currentButton = null

      return struct
    }
  }

  @Emit()
  editButton(): ButtonStruct | void {
    if (this.currentButton) {
      this.addedButton = false
      const struct = this.currentButton.create()
      struct.guid = this.oldGuid
      this.currentButton = this.manager.soloButton ? this.manager.firstButton : null

      return struct
    }
  }

  @Emit()
  removeButton(): ButtonStruct | void {
    if (this.struct) {
      this.addedButton = false
      this.currentButton = null
      this.oldGuid = ''

      return this.struct
    }
  }

  @Emit()
  unselect(): void {
    return
  }
}
